module.exports = __webpack_public_path__ + "img/img4.bc03064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img4.png
// module id = 268
// module chunks = 0